import React from 'react';
import { ClientType } from '../../ClientSearch.meta';
import { Lozenge } from '../../../CommonComponents/OPL/Lozenge/Lozenge';
import styled from '../../../theme/theme';

const StyledClientLozenge = styled(Lozenge)({
  textTransform: 'capitalize',
  width: 60,
  flexShrink: 0,
});

interface Props {
  clientType: ClientType;
}

export const ClientLozenge: React.FC<Props> = ({ clientType }) => {
  return (
    <StyledClientLozenge variantColor={clientType === ClientType.Prospect ? 'success' : 'default'}>
      {clientType}
    </StyledClientLozenge>
  );
};
